import * as React from 'react';

import type { TradeOffer } from './data-layer.types';

function useDataLayer(offer: any) {
  const isDefinedDataLayer  = React.useCallback(() => {
    if (!Array.isArray(window.dataLayer)) {
      window.dataLayer = undefined;

      return false;
    }

    return true;
  }, []);
  const defineDataLayer     = React.useCallback(() => {
    window.dataLayer = [
      {
        ecommerce: {
          currency: 'BYN',
          items:    [],
        },
        event:     'view_item',
      },
    ];
  }, []);
  const getDataLayer        = React.useCallback(() => {
    if (!isDefinedDataLayer()) {
      defineDataLayer();
    }

    return window.dataLayer;
  }, [defineDataLayer, isDefinedDataLayer]);
  const isDefinedViewItem   = React.useCallback(() => {
    return getDataLayer()
      ?.some((item) => {
        return item.event === 'view_item';
      });
  }, [getDataLayer]);
  const defineViewItem      = React.useCallback(() => {
    getDataLayer()
      ?.push({
        ecommerce: {
          currency: 'BYN',
          items:    [],
        },
        event:     'view_item',
      });
  }, [getDataLayer]);
  const getViewItem         = React.useCallback(() => {
    if (!isDefinedViewItem()) {
      defineViewItem();
    }

    return getDataLayer()?.[getDataLayer()
      ?.findIndex((item) => {
        return item.event === 'view_item';
      }) ?? -1];
  }, [defineViewItem, getDataLayer, isDefinedViewItem]);
  const isDefinedEcommerce  = React.useCallback(() => {
    return typeof getViewItem()?.ecommerce !== 'undefined';
  }, [getViewItem]);
  const defineEcommerce     = React.useCallback(() => {
    if (getViewItem()) {
      getViewItem()!.ecommerce = {
        currency: 'BYN',
        items:    [],
      };
    }
  }, [getViewItem]);
  const getEcommerce        = React.useCallback(() => {
    if (!isDefinedEcommerce()) {
      defineEcommerce();
    }

    return getViewItem()?.ecommerce;
  }, [defineEcommerce, getViewItem, isDefinedEcommerce]);
  const isDefinedItems      = React.useCallback(() => {
    return Array.isArray(getEcommerce()?.items);
  }, [getEcommerce]);
  const defineItems         = React.useCallback(() => {
    if (getEcommerce()) {
      getEcommerce()!.items = [];
    }
  }, [getEcommerce]);
  const getItems            = React.useCallback(() => {
    if (!isDefinedItems()) {
      defineItems();
    }

    return getEcommerce()?.items;
  }, [defineItems, getEcommerce, isDefinedItems]);
  const isDefinedTradeOffer = React.useCallback((id: number) => {
    return getItems()
      ?.some((item) => {
        return item.item_id === id;
      });
  }, [getItems]);
  const defineTradeOffer    = React.useCallback((data: TradeOffer) => {
    getItems()
      ?.push(data);
  }, [getItems]);

  if (!isSSR() && offer?.common?.ecommerce) {
    const {
            brand,
            id,
            label,
            price,
          } = offer.common.ecommerce;

    if (!isDefinedTradeOffer(id)) {
      defineTradeOffer({
        item_brand: brand,
        item_id:    id,
        item_name:  label,
        price:      price,
      });
    }
  }
}

export default useDataLayer;